document.querySelectorAll('[data-venta-finder]').forEach((root) => {
  if (root.dataset.vfReady === '1') return;
  root.dataset.vfReady = '1';

  const COLLECTION_URL = root.dataset.collectionUrl || '/collections/all';
  const PMIN = Number(root.dataset.pmin) || 1;
  const PMAX = Number(root.dataset.pmax) || 1000000;
  const LIMIT = Number(root.dataset.limit) || 14;
  const AUTOPLAY = root.dataset.autoplay === '1';
  const SPEED = Number(root.dataset.speed) || 4500;
  const SHOW_SKU = root.dataset.showSku === '1';
  const SKU_SEP = root.dataset.skuSep || '–';
  const LMIN = Math.log(PMIN), LMAX = Math.log(PMAX);

  const form = root.querySelector('[data-form]');
  const stage = root.querySelector('[data-stage]');
  const track = root.querySelector('[data-track]');
  const now = root.querySelector('[data-now]');
  const count = root.querySelector('[data-count]');
  const tmin = root.querySelector('[data-tmin]');
  const tmax = root.querySelector('[data-tmax]');
  const fill = root.querySelector('.vf__fill');
  const labMin = root.querySelector('[data-pmin-label]');
  const labMax = root.querySelector('[data-pmax-label]');
  const labFloor = root.querySelector('[data-floor-label]');
  const labCeil = root.querySelector('[data-ceiling-label]');
  const inMin = root.querySelector('[data-price-min-input]');
  const inMax = root.querySelector('[data-price-max-input]');
  const prevBtn = root.querySelector('[data-prev]');
  const nextBtn = root.querySelector('[data-next]');
  const kolSel = root.querySelector('[data-koltipi]');
  if (!form || !track) return;

  // Kol tipi secimi koleksiyon yolunu degistirir (etiket yolu), parametre eklemez.
  const BASE = COLLECTION_URL.replace(/\/+$/, '');
  function targetUrl() {
    return BASE + (kolSel && kolSel.value ? '/' + kolSel.value : '');
  }
  function syncAction() { form.setAttribute('action', targetUrl()); }

  const nf = new Intl.NumberFormat('tr-TR');
  const money = (v) => '₺' + nf.format(v);
  const snap = (v) => v <= 100000 ? Math.round(v / 1000) * 1000
                    : v <= 500000 ? Math.round(v / 5000) * 5000
                    : Math.round(v / 25000) * 25000;
  // Logaritmik skala: katalogun buyuk kismi alt bantta, tepe cok yukarida.
  const posToVal = (t) => t <= 0 ? PMIN : t >= 1000 ? PMAX : snap(Math.exp(LMIN + (t / 1000) * (LMAX - LMIN)));

  let items = [...track.children].map((el) => ({
    url: el.getAttribute('href'),
    title: el.dataset.title || '',
    price: el.dataset.price || '',
    sku: el.dataset.sku || '',
    img: el.querySelector('img') ? el.querySelector('img').getAttribute('src') : ''
  }));
  let active = 0, touched = false, timer = null, controller = null, debounce = null;

  // Urun kodu. Ilk yuklemede Liquid data-sku ile gelir. Filtre sonrasi
  // koleksiyon kartlarinda kod olmadigi icin yalnizca ekranda duran urun
  // icin /products/<handle>.js bir kez cekilir ve onbellege alinir.
  const skuCache = new Map();
  function handleOf(url) {
    const m = String(url || '').split('?')[0].match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }
  function fetchSku(p, idx) {
    if (!SHOW_SKU || p.sku || p.skuDone) return;
    const h = handleOf(p.url);
    if (!h) { p.skuDone = true; return; }
    p.skuDone = true;
    if (skuCache.has(h)) {
      p.sku = skuCache.get(h);
      if (p.sku && idx === active) caption();
      return;
    }
    fetch('/products/' + h + '.js')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        const s = d && d.variants && d.variants[0] ? (d.variants[0].sku || '') : '';
        skuCache.set(h, s);
        p.sku = s;
        if (s && idx === active) caption();
      })
      .catch(() => { skuCache.set(h, ''); });
  }

  function caption() {
    if (!now) return;
    const p = items[active];
    if (!p) {
      now.innerHTML = '<div class="vf__now-rule"></div><p class="vf__empty">Eşleşen tektaş yok, filtreleri gevşetin</p>';
      return;
    }
    const code = SHOW_SKU && p.sku
      ? ' <span class="vf__sku">' + SKU_SEP + ' ' + p.sku + '</span>'
      : '';
    now.innerHTML =
      '<div class="vf__now-rule"></div>' +
      '<p class="vf__now-title"><a href="' + p.url + '">' + p.title + code + '</a></p>' +
      (p.price ? '<p class="vf__now-price">' + p.price + '</p>' : '');
    fetchSku(p, active);
  }

  function place() {
    const els = [...track.children];
    const n = els.length;
    els.forEach((el, i) => {
      let off = i - active;
      if (n > 2) { if (off > n / 2) off -= n; if (off < -n / 2) off += n; }
      const a = Math.abs(off);
      const sc = off === 0 ? 1 : a === 1 ? .5 : a === 2 ? .32 : .28;
      const op = off === 0 ? 1 : a === 1 ? .5 : a === 2 ? .14 : 0;
      el.style.transform = 'translate(-50%,-50%) translateX(' + (off * 76) + '%) scale(' + sc + ')';
      el.style.opacity = op;
      el.style.zIndex = 5 - a;
      el.style.pointerEvents = a <= 1 ? 'auto' : 'none';
      el.classList.toggle('vf__item--active', off === 0);
      el.setAttribute('tabindex', off === 0 ? '0' : '-1');
    });
    caption();
  }

  function render() {
    track.innerHTML = '';
    items.forEach((p, i) => {
      const a = document.createElement('a');
      a.className = 'vf__item';
      a.href = p.url;
      if (p.title) a.setAttribute('aria-label', p.title);
      if (p.sku) a.dataset.sku = p.sku;
      if (p.img) {
        const img = document.createElement('img');
        img.src = p.img; img.alt = ''; img.loading = 'lazy';
        a.appendChild(img);
      }
      a.addEventListener('click', (e) => {
        if (i !== active) { e.preventDefault(); active = i; place(); }
      });
      track.appendChild(a);
    });
    active = 0;
    place();
  }

  // SI2 -> SI2 + SI, VS2 -> VS2 + VS
  function syncExtras() {
    form.querySelectorAll('input[data-extra-for]').forEach((inp) => {
      const s = form.querySelector('select[name="' + inp.dataset.extraFor + '"]');
      const opt = s ? s.options[s.selectedIndex] : null;
      const also = opt ? opt.dataset.also : null;
      if (also) { inp.value = also; inp.disabled = false; }
      else { inp.value = ''; inp.disabled = true; }
    });
  }

  function params() {
    const p = new URLSearchParams();
    form.querySelectorAll('select[name]').forEach((s) => { if (s.value) p.append(s.name, s.value); });
    form.querySelectorAll('input[data-extra-for]').forEach((i) => { if (!i.disabled && i.value) p.append(i.name, i.value); });
    if (touched && tmin && tmax) {
      p.set('filter.v.price.gte', posToVal(Number(tmin.value)));
      p.set('filter.v.price.lte', posToVal(Number(tmax.value)));
    }
    return p;
  }

  async function refresh() {
    if (controller) controller.abort();
    controller = new AbortController();
    stage.classList.add('is-loading');
    const qs = params().toString();
    try {
      const res = await fetch(targetUrl() + (qs ? '?' + qs : ''), { signal: controller.signal });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const m = html.match(/(\d+)\s*ürün/i);
      if (m && count) count.textContent = m[1];

      const parsed = [...doc.querySelectorAll('.card-product')].slice(0, LIMIT).map((c) => {
        const link = c.querySelector('a[href*="/products/"]');
        const img = c.querySelector('img');
        const heading = c.querySelector('.card__heading');
        const priceEl = c.querySelector('.price-indirim-ana__satis') || c.querySelector('.price');
        let src = '';
        if (img) {
          const ss = img.getAttribute('srcset');
          src = ss ? ss.split(',')[0].trim().split(' ')[0] : (img.getAttribute('src') || '');
        }
        const url = link ? link.getAttribute('href') : '#';
        return {
          url: url,
          title: (heading ? heading.textContent : (link ? link.textContent : '')).replace(/\s+/g, ' ').trim(),
          price: priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '',
          sku: skuCache.get(handleOf(url)) || '',
          img: src
        };
      }).filter((p) => p.img);

      // Ayristirma bozulursa karuseli bozma; sadece sayi guncellensin.
      if (parsed.length || (m && m[1] === '0')) { items = parsed; render(); }
    } catch (err) {
      if (err.name !== 'AbortError') { /* sessiz */ }
    } finally {
      stage.classList.remove('is-loading');
    }
  }

  function slider(evt) {
    if (!tmin || !tmax) return;
    let a = Number(tmin.value), z = Number(tmax.value);
    if (a > z - 20) {
      if (evt && evt.target === tmin) { a = z - 20; tmin.value = a; }
      else { z = a + 20; tmax.value = z; }
    }
    fill.style.left = (a / 10) + '%';
    fill.style.width = ((z - a) / 10) + '%';
    labMin.textContent = money(posToVal(a));
    labMax.textContent = money(posToVal(z));
    if (evt) {
      touched = true;
      inMin.disabled = false; inMax.disabled = false;
      inMin.value = posToVal(a); inMax.value = posToVal(z);
      clearTimeout(debounce);
      debounce = setTimeout(refresh, 400);
    }
  }

  form.querySelectorAll('select[name]').forEach((s) => {
    s.addEventListener('change', () => { syncExtras(); refresh(); });
  });
  if (kolSel) kolSel.addEventListener('change', () => { syncAction(); refresh(); });
  if (tmin) tmin.addEventListener('input', slider);
  if (tmax) tmax.addEventListener('input', slider);
  if (prevBtn) prevBtn.addEventListener('click', () => {
    if (items.length) { active = (active - 1 + items.length) % items.length; place(); }
  });
  if (nextBtn) nextBtn.addEventListener('click', () => {
    if (items.length) { active = (active + 1) % items.length; place(); }
  });

  const stop = () => { if (timer) clearInterval(timer); timer = null; };
  const start = () => {
    if (!AUTOPLAY) return;
    stop();
    timer = setInterval(() => {
      if (items.length > 1) { active = (active + 1) % items.length; place(); }
    }, SPEED);
  };
  stage.addEventListener('mouseenter', stop);
  stage.addEventListener('mouseleave', start);
  stage.addEventListener('focusin', stop);

  if (labFloor) labFloor.textContent = money(PMIN);
  if (labCeil) labCeil.textContent = money(PMAX);
  syncExtras();
  syncAction();
  slider(null);
  place();
  start();
});